import axios, { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';
import { clearCookies } from '../utils/CookieUtils';
import env from '../config/env';
import { downloadFile } from './DownloadHandler';
import { showErrorSnackbar, showSuccessSnackbar } from '../redux_store/slices/snackbarSlice';

function getErrorMessage(error: any) {
  if (error && error.response && error.response.data) {
    return error.response.data;
  }
  return error;
}

const api = axios.create({
  baseURL: `${env.API_BASE_URL}/`
});

//  Add authorization header to all requests
api.interceptors.request.use(config => {
  const token = Cookies.get('store_token');
  config.headers['context'] = 'Store';
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
    if (config.params !== undefined && 'downloadType' in config.params) {
      config.responseType = 'blob';
    }
  }
  return config;
});

//  dont thow error on 4XX status codes
api.interceptors.response.use(
  async (response: AxiosResponse) => {
    if (response?.config?.responseType === 'blob') {
      return await downloadFile(response);
    } else {
      let { data, error } = response.data;
      if (data === undefined) {
        data = response.data;
      }
      return Promise.resolve({
        ...response,
        data: !error && data,
        error: getErrorMessage(error)
      });
    }
  },
  error => {
    if (
      error.response.data?.message?.message === 'jwt expired' ||
      error.response.data?.message === 'Unauthorized, token not available' ||
      error.response.data?.message === 'invalid verified Token'
    ) {
      clearCookies();
    }
    return Promise.reject({ error: getErrorMessage(error) });
  }
);

export function handleResponse(
  response: any,
  fulfillWithValue: any,
  rejectWithValue: any,
  dispatch: any
) {
  if (response?.status === 200) {
    dispatch(showSuccessSnackbar({ message: response?.data }));
    return fulfillWithValue(response);
  } else {
    dispatch(showErrorSnackbar({ message: response?.data }));
    return rejectWithValue(response);
  }
}

export default api;
